import { render } from "./CourseMaker.vue?vue&type=template&id=72259dbc&scoped=true"
import script from "./CourseMaker.vue?vue&type=script&lang=js"
export * from "./CourseMaker.vue?vue&type=script&lang=js"

import "./CourseMaker.vue?vue&type=style&index=0&id=72259dbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72259dbc"]])

export default __exports__